import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  banner: null, // { type: 'success'|'info'|'error', message: string }
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    showBanner(state, action) {
      const payload = action.payload || {};
      const message = typeof payload.message === "string" ? payload.message : "";
      if (!message) return;
      state.banner = {
        type: payload.type || "info",
        message,
      };
    },
    clearBanner(state) {
      state.banner = null;
    },
  },
});

export const { showBanner, clearBanner } = uiSlice.actions;
export default uiSlice.reducer;
